"use client";

import { createContext, useContext, type ReactNode } from "react";
import { type DateRangeKey } from "@/store/useFilterStore";

type Option = { id: string | number; label: string };

type InitialFilters = {
  state?: string;
  city?: string;
  catId?: number;
  pType?: DateRangeKey;
};

type FiltersDataContextValue = {
  states?: Option[];
  categories?: Option[];
  citiesByStateId?: Record<string, Option[]>;
  initialFilters?: InitialFilters;
};

const FiltersDataContext = createContext<FiltersDataContextValue>({});

export function FiltersDataProvider({
  children,
  states,
  categories,
  citiesByStateId,
  initialFilters,
}: FiltersDataContextValue & { children: ReactNode }) {
  return (
    <FiltersDataContext.Provider
      value={{ states, categories, citiesByStateId, initialFilters }}
    >
      {children}
    </FiltersDataContext.Provider>
  );
}

export function useFiltersData() {
  return useContext(FiltersDataContext);
}
